import axios from 'axios'

const host = /releasestatic/.test(location.href) ? 'https://mapirelease.docbook.com.cn' : 'https://mapi.docbook.com.cn'
// const host = 'https://mapirelease.docbook.com.cn'

class Request {
    static get(url, params) {
        return new Promise(async (resolve, reject) => {
            resolve((await axios.get(host + url, params)).data)
        })
    }

    static post(url, data) {
        return new Promise(async (resolve, reject) => {
            resolve((await axios.post(host + url, data)).data)
        })
    }
    static sharePost(url, data) {
        return new Promise(async (resolve, reject) => {
            resolve((await axios.post(url, data)).data)
        })
    }
}

export default Request